import { Injectable } from '@angular/core';
import { environment } from '../../envs/environment';

declare let gtag: any;
declare let fbq: any;

@Injectable({
  providedIn: 'root'
})

export class TaggingService {

  // Google Tags
  trackGoogleEvent(eventName: string, tagId: string) {
    gtag('event', eventName, {
      'send_to': tagId
    })
  }

  // Meta Tags
  trackMetaEvent(eventName: string, action: string) {
    fbq(eventName, action);
  }

  /**
   * Envia eventos customizados e payloads estruturados para o dataLayer do GTM.
   *
   * O campo `environment` é adicionado automaticamente a todo payload para permitir
   * que o GTM diferencie eventos disparados em dev/qa dos disparados em produção
   * (ex: via Trigger de exceção configurado no container), evitando poluir os
   * relatórios reais do GA4/Google Ads/Meta com dados de teste.
   */
  pushDataLayer(payload: Record<string, any>): void {
    if (typeof window === 'undefined') {
      return;
    }
    const eventPayload = {
      ...payload,
      environment: environment.name
    };

    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.log('[TaggingService] pushDataLayer:', eventPayload);
    }

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(eventPayload);
  }
}
